import React from "react";
import { FormField, CardSection } from "../../Common/FormComponents";

const UNIT_PROPERTY_TYPE_OPTIONS = [
  { value: "", label: "Select Property Type" },
  { value: "apartment", label: "Apartment" },
  { value: "condo", label: "Condo" },
  { value: "duplex", label: "Duplex" },
  { value: "studio", label: "Studio" },
  { value: "loft", label: "Loft" },
  { value: "townhouse", label: "Townhouse" },
  { value: "office", label: "Office" },
  { value: "retail", label: "Retail" },
  { value: "other", label: "Other" },
];

const UnitDetailsSection = ({ formData, handleInputChange }) => (
  <CardSection title="Unit Details">
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "0.75rem" }}>
      <FormField label="Bedrooms" name="bedrooms" type="number" value={formData.bedrooms} onChange={handleInputChange} min="0" placeholder="0" />
      <FormField label="Bathrooms" name="bathrooms" type="number" value={formData.bathrooms} onChange={handleInputChange} min="0" step="0.5" placeholder="0" />
      <FormField label="Square Footage" name="squareFootage" type="number" value={formData.squareFootage} onChange={handleInputChange} min="0" placeholder="0" />
      <FormField label="Property Type" name="propertyType" type="select" value={formData.propertyType} onChange={handleInputChange} required options={UNIT_PROPERTY_TYPE_OPTIONS} />
      <FormField label="Layout" name="layout" value={formData.layout} onChange={handleInputChange} placeholder="e.g., Open concept" className="mb-0" />
    </div>
  </CardSection>
);

export default UnitDetailsSection;
